import { isValidEmail, isValidUSOrCanadianPhoneNumber, isValidMexicanPhoneNumber, isValidName, isValidAddressLine, isValid5DigitZip, isValid9DigitZip, validateAddress, isValidCanadianZip } from '@usas/ui-web/utils/validation';
import Constants, { DEFAULT_ID } from '@usas/ui-web/utils/Constants';

export const localValidate = async (formState) => {
  let errors = {};

  //First Name
  if (formState.firstName.trim() === '') {
    errors.firstName = 'First Name is required'
  } else if (!isValidName(formState.firstName.trim())) {
    errors.firstName = 'First Name must be a valid name'
  }

  //Last Name
  if (formState.lastName.trim() === '') {
    errors.lastName = 'Last Name is required'
  } else if (!isValidName(formState.lastName.trim())) {
    errors.lastName = 'Last Name must be a valid name'
  }

  //Contact Relationship Type Id
  if (formState.contactRelationshipTypeId === Constants.DEFAULT_ID) {
    errors.contactRelationshipTypeId = 'Relationship to Member is required'
  }

  // Email Address
  if (formState.email.trim() === '') {
    errors.email = 'Email Address is required'
  } else if (!isValidEmail(formState.email.trim())) {
    errors.email = 'Must be a valid Email Address'
  } else if (formState.email.trim().length > 512) {
    errors.email = 'Email Address cannot exceed 512 characters'
  }

  //Phone Number
  if (formState.phoneNumber.trim() === '') {
    errors.phoneNumber = 'Phone Number is required'
  } else if (!isValidUSOrCanadianPhoneNumber(formState.phoneNumber.trim()) && !isValidMexicanPhoneNumber(formState.phoneNumber.trim())) {
    errors.phoneNumber = 'Must enter a valid US, Canadian, or Mexican phone number in +1/+52 (XXX) XXX-XXXX format'
  }

  let addressError = false;

  //Address 1
  if (formState.address1.trim() === '') {
    addressError = true;
    errors.address1 = 'Address Line 1 is required'
  } else if (!isValidAddressLine(formState.address1.trim())) {
    addressError = true;
    errors.address1 = 'Address Line 1 cannot exceed 100 characters. Letters, numbers, number signs, spaces, periods, dashes, slashes, and apostrophes are allowed.';
  }

  if (formState.address2.trim() !== '' && !isValidAddressLine(formState.address2.trim())) {
    addressError = true;
    errors.address2 = 'Address Line 2 cannot exceed 100 characters. Letters, numbers, number signs, spaces, periods, dashes, slashes, and apostrophes are allowed.';
  }

  //  city
  if (formState.city.trim() === '') {
    addressError = true;
    errors.city = 'City is required'
  } else if (!isValidAddressLine(formState.city.trim())) {
    addressError = true;
    errors.city = 'City cannot exceed 100 characters. Letters, numbers, number signs, spaces, periods, dashes, slashes, and apostrophes are allowed.';
  }

  // Country
  if (formState.countryName?.trim()) {
    if (formState.countryCode === DEFAULT_ID || formState.countryCode === '') {
      addressError = true;
      errors.countryCode = 'Must be a valid country';
    }
  } else {
    addressError = true;
    errors.countryCode = 'Country is required';
  }

  // State
  if (formState.isCountryUSA === true || formState.isCountryMexico === true || formState.isCountryCanada === true) {
    if (formState.stateName !== '') {
      if (formState.stateCode === DEFAULT_ID || formState.stateCode === '') {
        addressError = true;
        errors.stateCode = 'Must be a valid state';
      }
    } else {
      addressError = true;
      errors.stateCode = 'State is required';
    }
  }

  // Zip Code
  if (formState.postalCode.trim() === '') {
    addressError = true;
    errors.postalCode = 'Zip Code is required';
  } else if ((formState.isCountryUSA === true) && !isValid5DigitZip(formState.postalCode.trim()) && !isValid9DigitZip(formState.postalCode.trim())) {
    addressError = true;
    errors.postalCode = 'United States Zip Code must be 5 digits, or 9 digits in XXXXX-XXXX format';
  } else if ((formState.isCountryCanada === true) && !isValidCanadianZip(formState.postalCode.trim())) {
    addressError = true;
    errors.postalCode = 'Canadian Zip Code must be valid and in A1A 1A1 format';
  } else if ((formState.isCountryMexico === true) && !isValid5DigitZip(formState.postalCode.trim())) {
    addressError = true;
    errors.postalCode = 'Mexican Zip Code must be 5 digits';
  }

  //Phone Type Id
  if (formState.phoneTypeId === Constants.DEFAULT_ID) {
    errors.phoneTypeId = 'Phone Type is required'
  }

  if (formState.isCountryUSA === true || formState.isCountryMexico === true || formState.isCountryCanada === true) {
    if (addressError === false
      && formState.showedAddressSuggestion === false) {
      formState.validatedAddress = await validateAddress(formState.address1?.trim(), formState.address2?.trim(), formState.city?.trim(), formState.stateCode, formState.postalCode?.trim());
      if (formState.validatedAddress.isValid === true
        && (
          formState.address1?.trim() !== formState.validatedAddress.address1?.trim()
          || formState.address2?.trim() !== formState.validatedAddress.address2?.trim()
          || formState.city?.trim() !== formState.validatedAddress.city?.trim()
          || formState.stateCode !== formState.validatedAddress.stateCode
          || formState.postalCode?.trim() !== formState.validatedAddress.postalCode?.trim()
        )
      ) {
        if (formState.address1?.trim() !== formState.validatedAddress.address1?.trim()) {
          errors.address1 = 'See Address Suggestion';
        }
        if (formState.address2?.trim() !== formState.validatedAddress.address2?.trim()) {
          errors.address2 = 'See Address Suggestion';
        }
        if (formState.city?.trim() !== formState.validatedAddress.city?.trim()) {
          errors.city = 'See Address Suggestion';
        }
        if (formState.stateCode !== formState.validatedAddress.stateCode) {
          errors.stateCode = 'See Address Suggestion';
        }
        if (formState.postalCode?.trim() !== formState.validatedAddress.postalCode?.trim()) {
          errors.postalCode = 'See Address Suggestion';
        }
      }
    }
  }

  return errors;
};

const PrimaryContactInfoValidation = async (formState) => {
  let errors = await localValidate(formState);

  return errors ? errors : {};
};
export default PrimaryContactInfoValidation;